import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { ConstructionConnectionState } from './types';

export const getters: GetterTree<ConstructionConnectionState, RootState> = {}
